import Grid from '@mui/material/Grid';
import SourceIcon from '@mui/icons-material/Source';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LzCModule from '@lz-modules/Module';
import LzXSwitchField from '@lz-components/forms/fields/SwitchField';
import LzXInputField from '@lz-components/forms/fields/InputField';
import SalesInvoiceModel from './SalesInvoices/sales-invoice.model';
import salesInvoiceCrudConfig from './SalesInvoices/config';
import SalesInvoiceAddScreen from './SalesInvoices/SalesInvoiceAddScreen';
import SalesInvoiceEditScreen from './SalesInvoices/SalesInvoiceEditScreen';
import SalesInvoicePrint from './SalesInvoices/SalesInvoicePrint';

// Create the module and use the customized entities in it
const ContentsModule = new LzCModule({
    ident: 'content',
    name: 'Content',
    icon: <SourceIcon />,
    children: [
        {
            variation: 'Entity',
            ident: 'sales-invoices',
            icon: <AssignmentIcon />,
            modelRef: SalesInvoiceModel,
            crud: salesInvoiceCrudConfig,
            listingGetInitFilters: (_, qsVars) => ({
                only_show_fbr_pending: 1 === +(qsVars?.onlyFbrPending || 0),
                invoice_no: '',
                invoice_date_from: '',
                invoice_date_to: '',
            }),
            listingGetFiltersInput: (data, handleInputChange) => (
                <Grid container spacing={1} key={'sales-invoices-listing-filters'} className="lz-sales-invoices-filters">
                    <Grid item sm={3}>
                        <LzXSwitchField fluid label="FBR Pending Invoices"
                            name="only_show_fbr_pending" value={data.only_show_fbr_pending} onChange={handleInputChange} />
                    </Grid>
                    <Grid item sm={3}>
                        <LzXInputField fluid compact variant="outlined" label="Search by Invoice No." labelShrinked
                            name="invoice_no" value={data.invoice_no} onChange={handleInputChange} />
                    </Grid>
                    <Grid item sm={3}>
                        <LzXInputField fluid compact variant="outlined" type="date" label="Invoice Date From"
                            name="invoice_date_from" value={data.invoice_date_from} onChange={handleInputChange} />
                    </Grid>
                    <Grid item sm={3}>
                        <LzXInputField fluid compact variant="outlined" type="date" label="Invoice Date To"
                            name="invoice_date_to" value={data.invoice_date_to} onChange={handleInputChange} />
                    </Grid>
                </Grid>
            ),
            listingShowFiltersInline: true,
            addComponent: <SalesInvoiceAddScreen />,
            editComponent: <SalesInvoiceEditScreen />,
        },
    ],
    routes: [
        { path: '/content/sales-invoices/:id/print', element: <SalesInvoicePrint /> },
    ],
});

export default ContentsModule;
